export enum EffortDemonstrated {
    NA = -1,
    NO,
    YES,
}
